import { gql } from 'apollo-boost';

export const GET_CREDITS_USAGE_PERCENT = gql`
    query GetCreditsUsagePercent {
        getCreditsUsagePercent
    }
`;
